//#region Imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
//#endregion Imports

//#region Internal Imports
import { HttpProvider } from 'app/core/common/http-provider.service';
import { User } from 'app/core/model/users/user.modal';

//#endregion Internal Imports

@Injectable({
  providedIn: 'root',
})
export class UserService extends HttpProvider {
  //#region Variable
//#region Endpoint

private readonly tagEndpoint = '/user/';
private readonly userListEndpoint = this.tagEndpoint;
private readonly userDataEndpoint = this.tagEndpoint;
private readonly userAddOrEditEndpoint = this.tagEndpoint;
private readonly organizationProgressEndpoint = '/organization_progress/';
private readonly userKycDataEndpoint = '/kyc/update_user/';
private readonly userListKycDataEndpoint = '/kyc/update_user_list/';
private readonly kycLinkEndpoint = '/kyc/generate_vcip_link/';
private readonly kycGetLinkEndpoint = '/kyc/get_vcip_link/';
private readonly toggleOnBoardEndpoint = '/on_boarded_status/';
private readonly changePasswordEndpoint = '/change_password/';
private readonly updateKycEndpoint = '/update_kyc_status/';
private readonly reTriggerEndpoint = '/re_trigger_password_mail/';
private readonly importUserEndpoint = '/user_import/';
private readonly userListByIdEndpoint = '/user_list/';
private readonly walletDataEndpoint = '/bank/user_kit/';
private readonly approverEndpoint = '/approver_dropdown/';
private readonly verifierEndpoint = '/verifer_dropdown/';
private readonly userMetaEndpoint = '/user_meta/';
private readonly assignKitEndpoint = '/assign_kit/';
private readonly userFieldUpdateEndpoint = '/user_field_update/';
private readonly generateKycLinkEndpoint = '/kyc/generate_kyc_link_for_user/';
private readonly userPermissionEndPoint = '/user_setting/';
private readonly userAndCardCountEndPoint = '/user_card_count/';
private readonly COuponCHeckEndPoint = '/organization-coupon//';

//#endregion

  //------------------\\
  userId: number = 0;
  userData: User = new User();
  //#endregion
  //#region Constructor
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  //#endregion

  //#region GET
  getUserList(role?: string, kycStatus?: string, mode?: string) {
    const queryParams: any = {};
    if (role) {
      queryParams.role_id = role;
    }
    if (kycStatus) {
      queryParams.kyc_status = kycStatus;
    }
    if (mode) {
      queryParams.mode = mode;
    }
    if (Object.keys(queryParams).length === 0) {
      return this.get(this.userListEndpoint);
    }
    return this.get(this.userListEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getUserData(id: any) {
    return this.get(this.userDataEndpoint + `${id}/`);
  }

  setUserObject(user: User) {
    this.userData = user;
  }

  getUserObject() {
    return this.userData;
  }
  //#endregion

  //#region POST
  addOrEditUser(data) {
    if (data.id != null && data.id != 0) {
      return this.put(this.userAddOrEditEndpoint + data.id + '/', data, true);
    } else {
      return this.post(this.userAddOrEditEndpoint, data, true);
    }
  }

  //#endregion

  //#region Delete
  deleteUser(id) {
    return this.delete(this.userDataEndpoint + `${id}/`);
  }

  //#endregion

  //#region
  getOrganizationProgress() {
    return this.get(this.organizationProgressEndpoint);
  }

  updateOrganizationProgress(data) {
    return this.put(this.organizationProgressEndpoint, data);
  }

  toggleOnBoardingProcess(id, status) {
    return this.put(this.toggleOnBoardEndpoint + `${id}/`, status);
  }

  updateKycData(value: any) {
    return this.put(this.userKycDataEndpoint + `${value.id}/`, value);
  }

  updateUserListForKYC(data: any) {
    return this.post(this.userListKycDataEndpoint, data);
  }

  getKycLinkForUser() {
    return this.post(this.kycLinkEndpoint, null);
  }
  updayeKycStatus(id, value) {
    return this.put('/user/' + `${id}/` + this.updateKycEndpoint, value);
  }

  getNewKYCLink(data) {
    return this.post(this.kycGetLinkEndpoint, data);
  }

  changePassword(form: any) {
    return this.put(this.changePasswordEndpoint, form);
  }

  reTriggerMail(data: any) {
    return this.post(this.reTriggerEndpoint, data);
  }

  importUser(fileData: any) {
    return this.post(this.importUserEndpoint, fileData, true);
  }

  getUserListById(data: any) {
    return this.post(this.userListByIdEndpoint, data);
  }

  getAssignedWallet(id: number) {
    const queryParams = {
      organization_id: id,
    };
    return this.get(this.walletDataEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getApproverDropdown(id) {
    const queryParams = {
      organization_id: id,
    };
    return this.get(this.approverEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getVerifierDropdown(id) {
    const queryParams = {
      organization_id: id,
    };
    return this.get(this.verifierEndpoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  //#endregion

  //#region  Getter n Setter

  public getUserId() {
    return this.userId;
  }

  public setUserId(id: number) {
    this.userId = id;
  }

  getUsersExcel() {
    const query_params = {
      export_type: 'excel',
    };
    return this.getBlob(this.userMetaEndpoint, true, query_params);
  }

  assignWallet(data) {
    return this.post(this.assignKitEndpoint, data);
  }

  saveUserField(data, id) {
    return this.put(this.userFieldUpdateEndpoint + `${id}/`, data);
  }

  generateKYCLink(data) {
    return this.post(this.generateKycLinkEndpoint, data);
  }

  getUserPermission(){
    return this.get(this.userPermissionEndPoint)
  }
  saveUserPermission(data){
    return this.post(this.userPermissionEndPoint,data)
  }

  getUserAndCardCount(id:number){
    const queryParams = {
      organization_id: id,
    };
    return this.get(this.userAndCardCountEndPoint, true, {
      params: this.toHttpParams(queryParams),
    });
  }

  getCouponDetails(){
    return this.get(this.COuponCHeckEndPoint);
  } 
  //#endregion
}
